import { PensionPot } from "./pensionPot";
import PermissionSet from "./permissionSet";

export default class PermissionService {
  public static getPermissionSet(pensionPot: PensionPot): PermissionSet {
    const canView = this.canViewPension(pensionPot);
    const canEdit = this.canEditPension(pensionPot);
    const canDelete = this.canDeletePension(pensionPot);

    return new PermissionSet(canView, canEdit, canDelete);
  }

  private static canViewPension(pensionPot: PensionPot) {
    return !PermissionService.canEditPension(pensionPot);
  }

  private static canEditPension(pensionPot: PensionPot) {
    return (
      pensionPot.userCanEditCurrentValue || pensionPot.userCanEditContribution
    );
  }

  private static canDeletePension(pensionPot: PensionPot) {
    return (
      pensionPot.userCanEditCurrentValue && pensionPot.userCanEditContribution
    );
  }
}
